import { classNames } from '../../utils/style-class.utils';
import { DialogPosition } from './models/DialogPosition';
export var bottomDiv = 'opacity-50 fixed inset-0 z-40 bg-black';
export var bottomDivSolid = 'fixed inset-0 z-40';
export var getWrapperStyle = function (position) {
    var baseStyle = 'justify-center flex overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none';
    switch (position) {
        case DialogPosition.Top:
            baseStyle = classNames(baseStyle, 'items-start');
            break;
        case DialogPosition.Middle:
            baseStyle = classNames(baseStyle, 'items-center');
            break;
        case DialogPosition.Bottom:
            baseStyle = classNames(baseStyle, 'items-end');
    }
    return baseStyle;
};
export var getContentWrapperStyles = function (stretch, dialogBorderRadiusType, fullScreen) {
    if (fullScreen) {
        return "bg-white relative w-full h-full";
    }
    var baseStyle = classNames(dialogBorderRadiusType === 'rounded' ? 'rounded-lg' : '', 'bg-white relative');
    return "".concat(baseStyle, " ").concat(stretch ? 'w-screen' : 'w-96', " sm:w-full");
};
//# sourceMappingURL=dialog.style.js.map